<template>
  <help-dialog title="AI Assistant (BETA)">
    <template #default>
      <div class="chat-log-help">
        <h3 class="mb-1 heading">
          <span class="title-highlight">Chat with your Workflow Assistant</span>
        </h3>
        <p class="body">
          Ask questions about your workflow, or tell the assistant what to change. It works through a request step by
          step — you can watch what it is doing as it happens, and stop it at any point. If an action can’t be carried
          out, the reason appears next to it, and the assistant usually adjusts and carries on. If a request needs more
          steps than one turn allows, it tells you what is still outstanding and offers to continue.
        </p>
        <br />
        <p class="body">
          All of your prompts, AI responses, and the actions taken are saved chronologically, so you can review
          decisions, audit changes, and pick up right where you left off. Whether you’re brainstorming improvements,
          creating events, or restructuring lanes, our assistant is here to guide you every step of the way.
        </p>
        <br />
        <p class="body">
          <b>Note:</b> This feature is currently in beta. We’re actively adding new actions and
          capabilities. Check back soon for even more automation options!
        </p>
        <br />
        <h4 class="mb-1 heading">Available actions</h4>
        <ul class="ml-5">
          <li v-for="action in availableActions" :key="action">
            <b>{{ action }}</b>
          </li>
        </ul>
        <br />
        <h4 class="mb-1 heading">Bulk AI actions</h4>
        <ul class="ml-5">
          <li v-for="action in bulkActions" :key="action">
            <b>{{ action }}</b>
          </li>
        </ul>
      </div>
    </template>
  </help-dialog>
</template>

<script setup>
import HelpDialog from '@/components/HelpDialog.vue'

const availableActions = [
  'Create / update / delete event or decision',
  'Add / remove connections between events',
  'Create / update / delete / reorder lane',
  'Create / update / delete group',
  'Create / update / delete card',
  'Create / update / delete entity',
  'Create / update / delete command',
  'Create / update / delete read model',
  'Create / update / delete domain event schema',
  'Create / update / delete bounded context',
  'Update workflow name'
]

const bulkActions = [
  'Plan workflow with AI',
  'Generate cards / commands / entities / read models from description',
  'Add missing cards / entities / commands / read models',
  'Regenerate cards / entities / commands / read models',
  'Analyze domain model',
  'Validate domain model',
  'Rollback workflow'
]

</script>

<style scoped>
.chat-log-help .heading {
  color: #000000;
}

.chat-log-help .body {
  color: #424242;
}

.chat-log-help .title-highlight {
  background-color: #EEEEEE;
}

[data-theme="dark"] .chat-log-help .heading {
  color: var(--text-dark);
}

[data-theme="dark"] .chat-log-help .body {
  color: var(--text-dark);
}

[data-theme="dark"] .chat-log-help .title-highlight {
  background-color: var(--light-3);
}
</style>
